module.exports = __webpack_public_path__ + "static/media/case4.cc53a3e1.png";